import React from "react";
import { ToastContainer, toast } from "react-toastify";
import { IconAlertError, IconAlertInformational, IconAlertSuccess } from "../../utils/icons";
import "react-toastify/dist/ReactToastify.css";
import "./UseAlert.css";

const toastKey = (type, msg, subMsg) => {
  const main = typeof msg === "string" || typeof msg === "number" ? String(msg) : null;
  if (main === null) return undefined;
  const sub = typeof subMsg === "string" || typeof subMsg === "number" ? String(subMsg) : "";
  return `${type}:${main}:${sub}`;
};

const shownAt = new Map();

const isDuplicate = (key, duration) => {
  const now = Date.now();
  shownAt.forEach((expiry, k) => {
    if (expiry <= now) shownAt.delete(k);
  });
  if (shownAt.has(key)) return true;
  shownAt.set(key, now + duration);
  return false;
};

const showAlert = (type, msg, subMsg = "", duration = 2000) => {
  const toastId = toastKey(type, msg, subMsg);
  if (toastId && (isDuplicate(toastId, duration) || toast.isActive(toastId))) return;

  const content = (
    <div className="toast-content">
      <div>{msg}</div>
      {subMsg && <div className="toast-subtext">{subMsg}</div>}
    </div>
  );

  const options = {
    icon: type === "success" ? <IconAlertSuccess /> : type === "info" ? <IconAlertInformational /> : <IconAlertError />,
    autoClose: duration,
    toastId,
  };

  if (type === "success") {
    toast.success(content, options);
  } else if (type === "info") {
    toast.info(content, options);
  } else if (type === "error") {
    toast.error(content, options);
  }
};

export const AlertContainer = () => (
  <ToastContainer
    key="toast-container"
    position="top-right"
    newestOnTop={false}
    closeOnClick
    theme="colored"
    hideProgressBar={true}
    icon={true}
    closeButton
  />
);

const UseAlert = () => [null, showAlert];

export default UseAlert;
